import { Toaster } from '@/components/ui/sonner'

type PortalToastContainerProps = {
  topOffset?: number
}

/**
 * Toaster scoped to its nearest positioned ancestor (widget box / chat page inset)
 * instead of the viewport: `position: absolute` overrides sonner's fixed default,
 * so overflow-clip keeps toasts inside the widget exactly like before.
 */
export const PortalToastContainer = ({ topOffset = 80 }: PortalToastContainerProps) => (
  <Toaster
    position="top-right"
    offset={{ top: topOffset, right: 16 }}
    mobileOffset={{ top: topOffset, right: 16, left: 16 }}
    style={{ position: 'absolute' }}
  />
)
